import { ComboboxItem } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { clinicQKeys } from "./queryKeys";


const queryFn = () => {
  return api.get("clinic/treatment-services");
};

const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: ComboboxItem[] = [];

    for (const i in res.data.reverse()) {
      const { name, _id } = res.data[i];

      newData.push({ label: name, value: _id });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

export const useGetClinicTreatmentPlans = () => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: clinicQKeys.treatmentPlans(),
    queryFn,
    select,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get All Clinic Treatment Plans]", res);
      handleErrors(res, "query");
    },
  });
};
